import React from 'react';
import SeoHead from '../components/SeoHead';
import { PAGE_SEO } from '../constants/seo';
import './Page.css';

const About = () => {
  return (
    <div className="page">
      <SeoHead {...PAGE_SEO.about} />
      <section className="page-header">
        <div className="container">
          <h1>About Unaffected Healthcare</h1>
          <p className="page-subtitle">Who we are & what we do</p>
        </div>
      </section>

      <section className="page-content">
        <div className="container">
          <div className="content-section">
            <h2>Who We Are</h2>
            <p>
              Unaffected Healthcare is a primary healthcare platform built for India&apos;s 
              working population—especially MSMEs and their employees. We combine teleconsultations, 
              diagnostics, medicines and preventive care into one simple experience so employers can 
              give their teams real healthcare, not just an insurance card.
            </p>
          </div>

          <div className="content-section">
            <h2>What We Do</h2>
            <div className="values-grid">
              <div className="value-item">
                <h3>Primary Care First</h3>
                <p>Unlimited doctor consults, follow‑ups and guidance that keep your team healthy and productive.</p>
              </div>
              <div className="value-item">
                <h3>Integrated Services</h3>
                <p>From online consults to lab tests and medicines, everything is connected so employees don&apos;t get lost in the system.</p>
              </div>
              <div className="value-item">
                <h3>Designed for MSMEs</h3>
                <p>Plans and workflows are built to be affordable, easy to roll out and simple to manage for HR and founders.</p>
              </div>
              <div className="value-item">
                <h3>Quality & Trust</h3>
                <p>We work only with certified doctors, accredited labs and verified pharmacy partners.</p>
              </div>
            </div>
          </div>

          <div className="content-section">
            <h2>Why It Matters</h2>
            <p>
              For most employees, the first touchpoint for healthcare is not a hospital—it&apos;s a 
              question, a symptom or a worry. By solving that first mile well, we help companies:
            </p>
            <ul className="benefits-list">
              <li>Reduce time lost in travel and waiting rooms</li>
              <li>Catch health issues early through proactive primary care</li>
              <li>Build a culture where employees feel genuinely cared for</li>
              <li>Control long‑term healthcare and attrition costs</li>
            </ul>
          </div>

          <div className="content-section">
            <h2>Our Story</h2>
            <p>
              At Unaffected, we are on a relentless mission to transform healthcare in India. 
              Our belief is simple: every individual deserves a high-quality life, with essential 
              healthcare services. Yet, the reality is stark—many still lack access to even the 
              most basic healthcare.
            </p>
            <p>
              We understand that healthcare is not just about treating illnesses; it&apos;s about 
              preventing them, managing them effectively, and ensuring that quality healthcare 
              is accessible and affordable for everyone, especially for MSMEs (Micro, Small, and 
              Medium Enterprises) and their employees.
            </p>
          </div>

          <div className="content-section">
            <h2>Our Mission</h2>
            <p>
              Making quality healthcare affordable for MSME. We are committed to providing 
              comprehensive healthcare solutions that empower businesses to take care of their 
              most valuable asset—their employees.
            </p>
          </div>

          <div className="content-section">
            <h2>What We Offer in Practice</h2>
            <div className="values-grid">
              <div className="value-item">
                <h3>Comprehensive Healthcare Services</h3>
                <p>From doctor consultations to lab tests, medicines to health check-ups—we provide end‑to‑end healthcare solutions.</p>
              </div>
              <div className="value-item">
                <h3>Certified Professionals</h3>
                <p>All our doctors, dieticians, and healthcare providers are certified and experienced professionals.</p>
              </div>
              <div className="value-item">
                <h3>Certified Labs</h3>
                <p>We partner with NABL/NABH certified laboratories to ensure accurate and reliable test results.</p>
              </div>
              <div className="value-item">
                <h3>Trusted Pharmacies</h3>
                <p>Order medicines from our network of trusted and verified pharmacies.</p>
              </div>
              <div className="value-item">
                <h3>Quick Access</h3>
                <p>Reduce consultation waiting time from 1 hour to just 15 minutes.</p>
              </div>
            </div>
          </div>

          <div className="content-section">
            <h2>Our Commitment</h2>
            <p>
              At Unaffected Healthcare, we are committed to making quality healthcare accessible, 
              affordable, and convenient. We understand the challenges faced by MSMEs and their 
              employees, and we&apos;re here to bridge the gap between quality healthcare and affordability.
            </p>
            <p>
              Join us in our mission to transform healthcare in India, one employee, one family, 
              one business at a time.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
